export const LOCAL_STORAGE_KEYS = {
    INSIGHT_LIST_FILTERS: "insight-list-filters",
    ASSESSMENT_FILTERS: (assessmentId: string) => `${assessmentId}-filters`,
} as const;

export type LocalStorageKey =
    | (typeof LOCAL_STORAGE_KEYS)[keyof typeof LOCAL_STORAGE_KEYS]
    | string;
